import React from "react";
import ReactAnimation from ".././ReactAnimation/ReactAnimation.js";
import Typist from "react-typist";
import "./Home.css";

export default function Home() {
  return (
    <div className="Home">
      <ReactAnimation />
      <div className="introduction">
        <span className="header-upper">Hello, I'm</span>
        <span className="header">Willie</span>
        <span className="header-lower">
          <span className="iam-text">I am a</span>
          <span className="typography-400">
            <Typist avgTypingDelay={80} startDelay={1000}>
              Full Stack Web Developer
            </Typist>
          </span>
        </span>
      </div>
    </div>
  );
}
